import React from 'react';
const SidePanel = ({ component: Component, props }) => {
    // const handleExportPDF = () => {
    //   exportToPDF('crossword-grid', 'crossword-puzzle.pdf');
    // };
    // const handlePrint = () => {
    //   printCrossword('crossword-grid');
    // };
    return (React.createElement("div", { className: "side-panel" },
        React.createElement("div", { className: "nav-container" },
            React.createElement("div", { className: "nav-content" },
                React.createElement(Component, { ...props })),
            React.createElement("div", { className: "nav-controls" },
                React.createElement("button", { className: "btn--primary nav-controls__submit", onClick: props?.onSubmit }, "SUBMIT")))));
};
export { SidePanel };
